import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'wuerth',
} as IModuleProps;
